import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function OAuthSuccess() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) {
      navigate("/login");
      return;
    }

    localStorage.setItem("token", token);

    const API = process.env.REACT_APP_API_URL || "https://doctor-appointment-1-yf2j.onrender.com";

    fetch(`${API}/api/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data?.user) {
          localStorage.removeItem("token");
          navigate("/login");
          return;
        }

        localStorage.setItem("user", JSON.stringify(data.user));
        navigate("/doctors");
      })
      .catch(() => {
        localStorage.removeItem("token");
        navigate("/login");
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#f0f9ff]">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-4 border-blue-200 border-t-[#1a6fa8] rounded-full animate-spin"></div>
          <p className="text-[#1a6fa8] text-sm font-medium">Logging you in...</p>
        </div>
      </div>
    );
  }

  return null; // render nothing once loading done
}

export default OAuthSuccess;